import { createCachedSearchService } from "./createCachedSearchService";

export const getProductsSuggestions = createCachedSearchService(
  "mekidoc-products",
  "products suggestions"
);
